import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Container } from "../../../../eva-components/Container";
import { RichText } from "../../../../eva-components/RichText";
import styles from "./HealthBanner.module.scss";
export const HealthBanner = ({ content, variant = "default", backgroundColor, borderColor, borderWidth, fontFamily, fontSize, textColor, width, height, }) => (_jsx("div", { className: classNames({
        "light-theme": variant !== "default",
    }, styles.wrapper, styles[variant]), style: {
        "--custom-health-banner-background-color": backgroundColor,
        "--custom-health-banner-text-color": textColor,
        "--custom-health-banner-font-size": fontSize,
        "--custom-health-banner-font-family": fontFamily,
        "--custom-health-banner-border-color": borderColor,
        "--custom-health-banner-border-width": borderWidth,
        "--custom-health-banner-width": width,
        "--custom-health-banner-height": height,
    }, children: _jsx("div", { className: styles.innerWrapper, children: _jsx(Container, { className: styles.container, children: _jsx("div", { className: classNames(styles.healthBannerContainer), "data-testid": "footerHealthBanner", children: _jsx(RichText, { className: classNames(styles.healthBannerContent, { [styles.customFontSizeDefinition]: fontSize }), content: content }) }) }) }) }));
//# sourceMappingURL=HealthBanner.js.map